import script from "./PublishersBrowse.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishersBrowse.vue?vue&type=script&setup=true&lang=js"

import "./PublishersBrowse.vue?vue&type=style&index=0&id=4f0932a7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0932a7"]])

export default __exports__